import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { logUsage } from 'owa-analytics';
export function isSubjectPickerSupported() {
    return (isMailFeatureEnabled('peo-subjectPicker') && isTabViewEnabled() && isInConversationView());
}
export function logSubjectPickerInitInfo() {
    if (isMailFeatureEnabled('peo-subjectPicker')) {
        logUsage('SubjectPicker_Init', {
            isTabViewEnabled: isTabViewEnabled(),
            isConversationView: isInConversationView(),
        }, null, {
            // This is temporary to get data in MSIT. Should be removed before starting Prod rollout
            // https://msfast.visualstudio.com/FAST/Office%20People%20HD/_workitems/edit/253222
            isCore: true,
        });
    }
}
function isInConversationView() {
    var globalListViewTypeReact = getUserConfiguration().UserOptions.GlobalListViewTypeReact ||
        0 /* Conversation */;
    return globalListViewTypeReact === 0 /* Conversation */;
}
//# sourceMappingURL=isSubjectPickerSupported.js.map